import { Rating, Box } from "@mui/material";
import { AppFeatureLookup } from "../../../../App/Constants/AbacConstants";
import { useFeaturePermission } from "../../../../App/State/Hooks/abacHooks";

function Ratings({ stars, setStars, readOnly }: { stars: number; setStars?: any; readOnly?: boolean }) {
  const starsString = Number.isInteger(stars) ? stars.toString() : stars.toFixed(2).toString();
  const titleString = readOnly ? `${starsString} / 5` : "Choose a rating";
  const addReviewAccess = useFeaturePermission(AppFeatureLookup.ProfileAddCandidateReviews);
  return (
    <Box title={titleString} sx={{ display: "inline" }}>
      <Rating
        value={stars}
        defaultValue={stars}
        onChange={addReviewAccess ? (event, newValue) => setStars(newValue ?? 0) : undefined}
        disabled={!addReviewAccess && !readOnly}
        precision={readOnly ? 0.1 : 1}
        readOnly={readOnly}
        size="large"
        sx={{
          "& .MuiRating-iconFilled": {
            color: "primary.main",
          },
          "& .MuiRating-iconHover": {
            color: "secondary.main",
          },
          "&.MuiRating-readOnly": {
            pointerEvents: "auto",
          },
        }}
      />
    </Box>
  );
}

export default Ratings;
